import "bootstrap/dist/css/bootstrap.css";
import "./src/assets/css/fonts.css";
import "./src/assets/css/app.css";
import "./src/assets/css/home.css";
import "./src/assets/css/company.css";
import "./src/styles/global.css";

import * as ReactGA from "react-ga";
ReactGA.initialize("UA-59053438-3");

//shouldUpdate scroll does not work with body ; use onRouteUpdate
export const onRouteUpdate = () => {
  if (typeof document === "undefined") return;

  // Force body scroll reset AFTER navigation (move to top of page after navigation)
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.scrollTo(0, 0);
};
